import { useState, useEffect, useContext } from "react";
import { db } from "../firebase";
import { UserContext } from "../UserContext";
import PulseLoader from "react-spinners/PulseLoader";
import SensorGroups from "./SensorGroups";
import SensorConfigMenu from "./SensorConfigMenu";
import PressureSensorsV3 from "./PressureSensorsV3";
import LineChartV3 from "./LineChartV3";
import BarGraphV3 from "./BarGraphV3";

export default function MonitoringV3({ pumpRoomRef }) {
  const [device, setDevice] = useState();
  const [pressureSensors, setPressureSensors] = useState([]);
  const [userRef, setUserRef] = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [lastComm, setLastComm] = useState("");
  const [showSensorConfig, setShowSensorConfig] = useState(false);
  const [selectedForLogs, setSelectedForLogs] = useState();
  const [sensorGroups, setSensorGroups] = useState([]);
  const [pumps, setPumps] = useState([]);
  const [alarms, setAlarms] = useState([]);
  const [sensors, setSensors] = useState([]);
  const [selectedForBarGraph, setSelectedForBarGraph] = useState();

  function updateSelectedForLogs(selection) {
    setSelectedForLogs(selection);
  }

  function updateSelectedForBarGraph(selection) {
    setSelectedForBarGraph(selection);
  }

  useEffect(() => {
    if (device) {
      const commDate = new Date(device.lastCommTimestamp.toDate());
      setLastComm(
        new Date(commDate).toLocaleString("en-US", {
          timeZone: "America/New_York",
        })
      );
    }
  }, [device]);

  const closeChart = () => {
    setSelectedForLogs();
  };

  const closeGraph = () => {
    setSelectedForBarGraph();
  };

  useEffect(() => {
    setTimeout(() => {
      if (pumpRoomRef.monitoring_enabled === 1) {
        const unsubscribe = db
          .collection("devices")
          .doc(pumpRoomRef.device)
          .onSnapshot((doc) => {
            setDevice(doc.data());
            setLoading(false);
          });

        return () => {
          unsubscribe();
        };
      } else {
        setLoading(false);
      }
    }, [200]);
  }, [pumpRoomRef]);

  useEffect(() => {
    let unsubscribeSensorGroups,
      unsubscribePumps,
      unsubscribeAlarms,
      unsubscribePressure;

    if (device) {
      unsubscribeSensorGroups = db
        .collection("devices")
        .doc(device.id)
        .collection("groups")
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setSensorGroups(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribePumps = db
        .collection("devices")
        .doc(device.id)
        .collection("pumps")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setPumps(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribeAlarms = db
        .collection("devices")
        .doc(device.id)
        .collection("alarms")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setAlarms(snapshot.docs.map((doc) => doc.data()));
        });

      unsubscribePressure = db
        .collection("devices")
        .doc(device.id)
        .collection("pressureSensors")
        .where("enabled", "==", true)
        .orderBy("position")
        .onSnapshot((snapshot) => {
          setPressureSensors(snapshot.docs.map((doc) => doc.data()));
        });
    }

    return () => {
      if (unsubscribeSensorGroups) unsubscribeSensorGroups();
      if (unsubscribePumps) unsubscribePumps();
      if (unsubscribeAlarms) unsubscribeAlarms();
      if (unsubscribePressure) unsubscribePressure();
    };
  }, [device]);

  useEffect(() => {
    setSensors([...pumps, ...alarms]);
  }, [pumps, alarms]);

  return (
    <div>
      <PulseLoader
        color={"#ffffff"}
        loading={loading}
        size={20}
        className="loader"
      />
      {loading === false && (
        <div>
          {selectedForLogs || selectedForBarGraph ? (
            <>
              {selectedForLogs ? (
                <LineChartV3
                  deviceID={pumpRoomRef.device}
                  sensorID={selectedForLogs.id}
                  closeChart={closeChart}
                  sensorName={selectedForLogs.name}
                />
              ) : (
                <BarGraphV3
                  deviceID={pumpRoomRef.device}
                  pumpID={selectedForBarGraph.id}
                  closeGraph={closeGraph}
                  inputName={selectedForBarGraph.name}
                />
              )}
            </>
          ) : (
            <>
              {!showSensorConfig ? (
                <div>
                  {pumpRoomRef.monitoring_enabled && device ? (
                    <div>
                      <div className="pumpRoomHeading2">
                        <h2>Monitoring</h2>
                        {userRef.canAccessInputConfig && (
                          <div>
                            <button
                              className="spaceBtn"
                              onClick={() => setShowSensorConfig(true)}
                            >
                              SENSOR CONFIG
                            </button>
                          </div>
                        )}
                      </div>
                      {lastComm.length > 0 && (
                        <div className="margin1">
                          <div className="bold sectionSpacer">
                            LAST CHECK-IN:
                          </div>
                          <div>{lastComm}</div>
                        </div>
                      )}
                      {sensorGroups.length > 0 && (
                        <SensorGroups
                          groups={sensorGroups}
                          sensors={sensors}
                          updateSelectedForBarGraph={updateSelectedForBarGraph}
                        />
                      )}
                      {pressureSensors.length > 0 && (
                        <PressureSensorsV3
                          sensors={pressureSensors}
                          updateSelectedForLogs={updateSelectedForLogs}
                        />
                      )}
                    </div>
                  ) : (
                    <div className="middleContainer">
                      NO ACTIVE REMOTE MONITORING PLAN
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="pumpRoomHeading2">
                    <h2>Sensor Config</h2>
                    <div>
                      <button
                        className="spaceBtn"
                        onClick={() => setShowSensorConfig(false)}
                      >
                        CLOSE
                      </button>
                    </div>
                  </div>
                  <SensorConfigMenu deviceID={pumpRoomRef.device} />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
